import React from 'react';
import moment from "moment";
import { Input, TreeSelect, Radio, DatePicker,Select } from 'antd';

import "./style.css";


export default class DynamicFilter extends React.Component {

	// componentWillReceiveProps(nextProps) {
	// 	console.log(nextProps)
	// }

	state = {}

	renderTreeNodes = data => data.map(item => {
		if (item.children) {
			return (
				<TreeSelect.TreeNode title={item.name}
					value={item.id + ""}
					key={item.id}
					dataRef={item}>
					{item.children.length !== 0 && this.renderTreeNodes(item.children)}
				</TreeSelect.TreeNode>
			);
		}
		return <TreeSelect.TreeNode {...item} />
	})

	setNameFilter = value => this.props.setFilter({
		employee_info: value,
		page:1
	}, "reload")

	changeNameFilter = event => {
		if (event.target.value) {
			this.props.setFilter({
				employee_info: event.target.value,
				page:1
			})
		}
	}

	setDepartmentFilter = value => this.props.setFilter({
		department_id: value,
		page:1
	}, "reload")

	setRadioFilter = (key, event) => this.props.setFilter({
		[key]: event.target.value,
		page:1
	}, "reload")

	setMonthFilter = (key, moment) => this.props.setFilter({
		[key]: moment ? moment.format("YYYY-MM") : ""
	}, "reload")

	setDateFilter = (key, moment) => this.props.setFilter({
		[key]: moment ? moment.format("YYYY-MM-DD") : "",
		page:1
	}, "reload")

	setSelectFilter = (key, value) => this.props.setFilter({
		[key]: value,
		
	}, "reload")

	render() {
		return (
			<div>
				{this.props.column.map((column, index) => {
					switch (column.type) {
						case "person":
							return (
								<div className="colAction" key={index}
									style={{ float: "right", margin: "0px 10px 10px 0px" }}>
									<Input.Search
										placeholder= "请输入工号或姓名" //{column.label}
										onSearch={this.setNameFilter}
										onChange={this.changeNameFilter}
										style={{ width: 200 }}
										defaultValue={this.props.value.employee_info}
										enterButton />
								</div>
							)
							case "text":
							return (
								<div className="colAction" key={index}
									style={{ float: "right", margin: "0px 10px 10px 0px" }}>
									<Input
										placeholder= "请输入工号或姓名" //{column.label}
										onChange={this.changeNameFilter}
										style={{ width: 200 }}
										defaultValue={this.props.value.employee_info}
										 />
								</div>
							)
						case "department":
							return (
								<div className="colAction" key={index}
									style={{ float: "right", margin: "0px 10px 10px 0px" }}>
									<TreeSelect style={{ minWidth: "300px" }}
										placeholder="请选择部门"
										showSearch={false}
										autoExpandParent={true}
										allowClear
										dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
										treeDefaultExpandAll
										defaultValue={this.props.value.department_id}
										onChange={this.setDepartmentFilter}>
										{this.props.departmentsList &&
											this.renderTreeNodes(this.props.departmentsList)}
									</TreeSelect>
								</div>
							)
						case "month":
							return (
								<div className="colAction" key={index}
									style={{ float: "right", margin: "0px 10px 10px 0px" }}>
									<span>{column.label}: </span>
									<DatePicker.MonthPicker defaultValue={this.props.value[column.key] ? moment(this.props.value[column.key]) : null}
										onChange={this.setMonthFilter.bind(this, column.key)} />
								</div>
							)
						case "date":
							return (
								<div className="colAction" key={index}
									style={{ float: "right", margin: "0px 10px 10px 0px" }}>
									<span>{column.label}: </span>
									<DatePicker defaultValue={this.props.value[column.key] ? moment(this.props.value[column.key]) : null}
									format={column.format?column.format:"YYYY-MM-DD"}
										onChange={this.setDateFilter.bind(this, column.key)} />
								</div>
							)
						case "radio":
							return (
								<div className="colAction" key={index}
									style={{ float: "right", margin: "0px 10px 10px 0px" }}>
									<Radio.Group defaultValue={this.props.value[column.key]}
										onChange={this.setRadioFilter.bind(this, column.key)}>
										{column.children.map((child, childIndex) => (
											<Radio.Button key={childIndex}
												value={child.id}>{child.text}</Radio.Button>
										))}
									</Radio.Group>
								</div>
							)
						case "select":
							return (
								<div className="colAction" key={index} style={{ float: "right", margin: "0px 10px 10px 0px" }}>
									<Select style={{ width: 200 }} placeholder={column.label} defaultValue={column.defaultValue} onChange={this.setSelectFilter.bind(this, column.key)}>
										{column.children.map((child, childIndex) => (
											<Select.Option value={childIndex}>{child.text}</Select.Option>
										))}
									</Select>
								</div>
							)
							case "selectValue":
							return (
								<div className="colAction" key={index} style={{ float: "right", margin: "0px 10px 10px 0px" }}>
									<Select style={{ width: 200 }} placeholder={column.label} defaultValue={column.defaultValue} onChange={this.setSelectFilter.bind(this, column.key)}>
										{column.children.map((child) => (
											<Select.Option key={child.id} value={child.id}>{child.text}</Select.Option>
										))}
									</Select>
								</div>
							)
						default:
							return null
					}
				})}
			</div>
		)
	}
}






// WEBPACK FOOTER //
// ./src/components/frame/DynamicFilter.js